const Users = { service: 'auth', model: 'Users' };

export default {
  actions: {
    logout({ dispatch }) {
      return dispatch('Acacia/Utils/Resources/POST', {
        ...Users,
        url: '/logout',
      }).then(() => {
        dispatch('Acacia/GoToLogin');
        return true;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js